module.exports = __webpack_public_path__ + "static/media/TheGrandBliss.1944b895.png";